import React, { useState } from 'react';
import request from 'services/http';
import PageHeader from 'components/PageHeader';
import { Icon, Divider, Header, Table, Message, Loader, Menu, Label } from 'semantic-ui-react';
import { finalize, tap } from 'rxjs/operators';
import Payment from './Pagamento';
import FormularioPesquisa from './FormularioPesquisa';
import { toast } from 'react-toastify';
import produce from 'immer';
import './coletaDados.scss';

export default function ColetaDados() {
    const [payments, setPayments] = useState({
        request: 0,
        data: [],
        loading: false,
        lastOrder: '',
        order: false,
        pages: 0,
        atualPage: 1,
        query: '',
    });

    const handleData = (query) => {
        setPayments({ request: true, data: [], loading: true });

        const req = request({
            method: 'GET',
            url: `/recebiveis/coleta-de-dados/?${query || ''}${query ? '&' : ''}page=1`,
        })
            .pipe(
                tap(({ response }) => {
                    if (response.amount === 0) {
                        toast.error('Nenhum dado encontrado');
                    }
                    return setPayments({
                        request: true,
                        data: response.data,
                        pages: response.amount,
                        atualPage: 1,
                        loading: false,
                        lastOrder: '',
                        order: false,
                        query: query,
                    });
                }),
                finalize(() => req.unsubscribe()),
            )
            .subscribe();
    };

    const handlePages = (page) => {
        if (page === payments.atualPage || payments.pages < page || page < 1) {
            return;
        }
        setPayments({ request: true, data: [], loading: true });

        const req = request({
            method: 'GET',
            url: `/recebiveis/coleta-de-dados/${payments.query || ''}&page=${page}`,
        })
            .pipe(
                tap(({ response }) => {
                    if (response.length === 0) {
                        toast.error('Nenhum dado encontrado');
                    }
                    return setPayments({
                        request: true,
                        data: response.data,
                        pages: payments.pages,
                        atualPage: page,
                        loading: false,
                        lastOrder: '',
                        order: false,
                        query: payments.query,
                    });
                }),
                finalize(() => req.unsubscribe()),
            )
            .subscribe();
    };

    const createPages = [];

    const pagination = {
        max: payments.pages,
        min: 1,
        begin: payments.atualPage - 1 <= 0 ? 1 : payments.atualPage - 1,
        end: payments.atualPage + 1 > payments.pages ? payments.pages : payments.atualPage + 1,
        midle: (n) => n > 1 && n < payments.pages,
    };

    for (let i = pagination.begin; i <= pagination.end; i++) {
        if (pagination.begin === i) {
            createPages.push(
                <Menu.Item key={1} onClick={() => handlePages(1)} content={1} as="a" />,
            );
        }

        if (pagination.midle(i)) {
            createPages.push(
                <Menu.Item key={i} onClick={() => handlePages(i)} content={i} as="a" />,
            );
        }

        if (pagination.end === i) {
            createPages.push(
                <Menu.Item
                    key={payments.pages}
                    onClick={() => handlePages(payments.pages)}
                    content={payments.pages}
                    as="a"
                />,
            );
        }
    }

    const sortTable = (key) => {
        setPayments(
            produce(payments, (draft) => {
                const orderedPays = draft.data.sort((a, b) => {
                    if (payments.lastOrder !== key || !payments.order) {
                        switch (key) {
                            case 'valor_total':
                                return a[key] < b[key] ? 1 : b[key] < a[key] ? -1 : 0;

                            default:
                                return a[key] > b[key] ? 1 : b[key] > a[key] ? -1 : 0;
                        }
                    } else {
                        switch (key) {
                            case 'valor_total':
                                return a[key] > b[key] ? 1 : b[key] > a[key] ? -1 : 0;

                            default:
                                return a[key] < b[key] ? 1 : b[key] < a[key] ? -1 : 0;
                        }
                    }
                });

                if (draft.lastOrder === key) {
                    draft.order = !payments.order;
                } else {
                    draft.lastOrder = key;
                    draft.order = true;
                }

                draft.data = orderedPays;
            }),
        );
    };

    return (
        <div className="page-content">
            <PageHeader />
            <div id="coleta-dados" className="subcontent pr-2 pl-2 pb-4">
                <Header as="h3" className="mt-4 ml-4">
                    <Icon.Group size="big">
                        <Icon name="tasks" className="primary-color" />
                    </Icon.Group>
                    <Header.Content className="primary-color">
                        Coleta de Dados
                        <Header.Subheader className="secondary-color">
                            <strong>Ticket LOG e Pró-Frota</strong>
                        </Header.Subheader>
                    </Header.Content>
                </Header>

                <Divider fitted style={{ margin: '0 12px 10px 12px', borderTopWidth: '2px' }} />

                <FormularioPesquisa handleData={handleData} />

                {!payments.loading && payments.data.length === 0 ? (
                    <Message
                        header="Exibição de dados"
                        content="Preencha o filtro acima para realizar uma busca e exibir os dados com as características requeridas"
                        floating
                    />
                ) : payments.loading ? (
                    <Loader active={payments.loading} content="Buscando dados" />
                ) : (
                    <Table selectable>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => sortTable('nome_empresa')}
                                >
                                    Empresa
                                </Table.HeaderCell>

                                <Table.HeaderCell
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => sortTable('valor_total')}
                                >
                                    Valor
                                </Table.HeaderCell>

                                <Table.HeaderCell
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => sortTable('type')}
                                    textAlign="center"
                                >
                                    Tipo
                                </Table.HeaderCell>

                                <Table.HeaderCell
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => sortTable('cidade')}
                                >
                                    Cidade
                                </Table.HeaderCell>

                                <Table.HeaderCell
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => sortTable('data_pgto')}
                                    textAlign="center"
                                >
                                    Data Pagamento
                                </Table.HeaderCell>

                                <Table.HeaderCell
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => sortTable('estado')}
                                    textAlign="center"
                                >
                                    Estado
                                </Table.HeaderCell>

                                <Table.HeaderCell textAlign="center">Status</Table.HeaderCell>

                                <Table.HeaderCell textAlign="center">Informações</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {payments.data.map((pay) => (
                                <Payment key={pay.id} payment={pay} />
                            ))}
                        </Table.Body>
                        <Table.Footer>
                            <Table.Row>
                                <Table.HeaderCell
                                    content={`${payments.data.length} itens encontrados`}
                                />
                                <Table.HeaderCell />
                                <Table.HeaderCell />

                                <Table.HeaderCell>
                                    <Label
                                        size="large"
                                        content={`Página: ${payments.atualPage}`}
                                        horizontal
                                    />
                                </Table.HeaderCell>
                                <Table.HeaderCell colSpan="8">
                                    <Menu floated="right" pagination>
                                        <Menu.Item
                                            as="a"
                                            onClick={() => handlePages(payments.atualPage - 1)}
                                        >
                                            <Icon name="chevron left" />
                                        </Menu.Item>
                                        {createPages}
                                        <Menu.Item
                                            as="a"
                                            onClick={() => handlePages(payments.atualPage + 1)}
                                        >
                                            <Icon name="chevron right" />
                                        </Menu.Item>
                                    </Menu>
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Footer>
                    </Table>
                )}
            </div>
        </div>
    );
}
